<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Choose a Text</cs-header-title>
  <cs-header-content>
    <div class="controls-row">
      <cs-input class="search-input" iconName="search" autocomplete="off" [(value)]="searchText"
        type="text" name="searchText" inputmode="search" [placeholder]="'Search texts...' | untranslated"
        (input)="handleSearchChanged()" />
      <cs-button tertiary icon="add" (click)="newText()">Create Text</cs-button>
    </div>
  </cs-header-content>
</cs-header>

<cs-content>
  <cs-table class="text-table">
    @for (e of filteredTexts; track e) {
      <cs-table-row clickable (rowClick)="editText(e)">
        <cs-table-cell>{{ formatId(e) }}</cs-table-cell>
        <cs-table-cell>{{ formatName(e) }}</cs-table-cell>
        <cs-table-cell>
          <cs-button secondary small (click)="previewText(e); $event.stopPropagation();" [label]="'Preview' | untranslated" icon="eye"></cs-button>
        </cs-table-cell>
      </cs-table-row>
    }
  </cs-table>
</cs-content>